export default {
    capitalize(value) {
        let text = value;
        if (text) {
            text = text.toLowerCase().replace(/\b[a-z]/g, letter => letter.toUpperCase());
        }
        return text;
    },
    /**
     * Converts kebab-case string to camelCase
     * @param {string} str - The kebab-case string to convert
     * @returns {string} The camelCase version of the string
     */
    kebabToCamel(str) {
        if (!str) {
            return str;
        }
        return str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
    },
};
